import { DatePipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';

import { ObserverMapFacadeService } from '../../services/observer-map-facade.service';

@Component({
  selector: 'app-drone-details-panel',
  imports: [DatePipe],
  templateUrl: './drone-details-panel.component.html',
  styleUrl: './drone-details-panel.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DroneDetailsPanelComponent {
  protected readonly facade = inject(ObserverMapFacadeService);
}
